// Port of api/fuel/app/classes/filter/search/games/filters/query/game/bgg/owners.php
import { rangeActive } from 'offline/filter/core/search/unit'
export default {
	name: 'bgg.owners',
	priority: 65,
	require: function(config, filter) { return filter.bgg && rangeActive(filter.bgg.owners, 0, 99999999) },
	run: function(config, filter, data, query) {
		if (filter.bgg.owners.from > 0) query.where('g.game_own', '>=', filter.bgg.owners.from)
		if (filter.bgg.owners.to < 99999999) query.where('g.game_own', '<=', filter.bgg.owners.to)
	}
}
